export default __webpack_public_path__ + "static/4-7e6e8ed7636094779945286ea70e3087.jpeg";